import React from "react";
import "./AboutUsPage.css";
import img from "../images/Aboutus.png";
import img02 from "../images/ExploreEast/tsomgo.jpg";
import img01 from "../images/ExploreEast/mg-marg.jpg";
import img03 from "../images/ExploreWestnSouth/CharDham.jpeg";
import img04 from "../images/ExploreWestnSouth/Samdtuptse.jpeg";
import img05 from "../images/ExploreWestnSouth/TemiTea .jpeg";
import img06 from "../images/ExploreNorth/Nathula.jpeg";
import img07 from "../images/ExploreDarjeeling/Chowrasta.jpeg";
import mission from "../images/Mission.png";
import vision from "../images/Vision.png";

const AboutPage = () => {
  return (
    <div className="about-page">

      {/* HERO SECTION */}
      <section className="about-hero">

        <div className="hero-content">
          <h1>About Us!</h1>

          <h2>
            Travel more, Worry less!
            <br />
            We’ll take you there!
          </h2>

          <p>
            Flamingo Tours and Travels, your trusted travel partner located
            in the heart of Gangtok. Established in 2022, we are committed
            to delivering seamless, memorable, and personalized travel
            experiences across Sikkim and Darjeeling.
          </p>
        </div>

        <div className="hero-image">
          <img src={img} alt="" />
        </div>

      </section>

      {/* MORE OF US */}
      <section className="more-us">

        <h2>MORE OF US!</h2>

        <div className="more-container">

          {/* LEFT HONEYCOMB */}
          <div className="hex-gallery">

  <div className="hex-row">
    <div className="hex">
      <img src={img01} alt="" />
    </div>

    <div className="hex">
      <img src={img02} alt="" />
    </div>
  </div>

  <div className="hex-row middle">
    <div className="hex">
      <img src={img03} alt="" />
    </div>

    <div className="hex">
      <img src={img05} alt="" />
    </div>

    <div className="hex">
      <img src={img04} alt="" />
    </div>
  </div>

  <div className="hex-row">
    <div className="hex">
      <img src={img06} alt="" />
    </div>

    <div className="hex">
      <img src={img07} alt="" />
    </div>
  </div>

</div>

          {/* RIGHT CONTENT */}
          <div className="more-content">

            <p>
              At Flamingo Tours and Travels, we offer a wide range of
              services including customized tour packages, hotel bookings,
              transport arrangements, and permits for restricted areas like
              Nathula and North Sikkim. Whether you're planning a relaxing
              getaway, an adventure trip, or a family vacation, we handle
              every detail with care and professionalism.
            </p>

            <h3>
              We turn your journey into a beautiful story
              which will be worth remembering!
            </h3>

          </div>

        </div>
      </section>

      {/* MISSION & VISION */}
      <section className="mission-vision">

        <div className="mv-card">

          <div className="corner top-left"></div>
          <div className="corner top-right"></div>
          <div className="corner bottom-left"></div>
          <div className="corner bottom-right"></div>

          <img src={mission} alt="Mission"/>

          <h2>OUR MISSION</h2>
          
          <p>
            To inspire to explore the world with responsible travel,
            exceptional service and authentic experiences that create
            lifelong memories.
          </p>
        </div>

        <div className="mv-card">

          <div className="corner top-left"></div>
          <div className="corner top-right"></div>
          <div className="corner bottom-left"></div>
          <div className="corner bottom-right"></div>

          <img src={vision} alt="Vision"/>

          <h2>OUR VISSION</h2>
          
          <p>
            To be a trusted travel partner known for creating extraordinary
            journeys that connect people, cultures and beautiful destinations.
          </p>
        </div>

      </section>

    </div>
  );
};

export default AboutPage;